import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdvertisers } from "../firebase";

import "./advertisers.css";
import KevelAdvertisers from "./advertisers/kevel_advertisers";
import GamAdvertisers from "./advertisers/gam_advertisers";

const Advertisers = ({ retailer }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  useEffect(() => {
    getAdvertisers(retailer.name, user, dispatch);
  }, [retailer, user, dispatch]);

  const SupplierComponent = (props) => {
    const components = {
      kevel: KevelAdvertisers,
      gam: GamAdvertisers,
    };

    const SupComponent = components[props.component];
    const renderComponent = <SupComponent {...props} />;

    return <>{renderComponent}</>;
  };

  return (
    <SupplierComponent component={retailer.service} retailer={retailer.name} />
  );
};

export default Advertisers;
